export const endpoints = {
  SIGNUP: '/users/signup',
  LOGIN: '/users/login',
  LOGOUT: '/users/logout',
  WALLET_CREDENTIALS: '/wallet/credentials',
  VC_BUILD_UNSIGNED: '/vc/build-unsigned',
  WALLET_SIGN_CREDENTIALS: '/wallet/sign-credential',
  DID_RESOLVE_DID: '/did/resolve-did',
  VERIFIER_VERIFY_VCS: '/verifier/verify-vcs',
  MESSAGE:'/messages'
}